function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.jollyVariables.currency_code_enabled ? window.jollyVariables.money_with_currency_format : window.jollyVariables.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
function pushCartDataLayer() {
  fetch("/cart.js").then((response) => response.json()).then((cart) => {
    const items = cart.items.map((item) => ({
      item_id: item.id,
      item_variant: item.variant_title || "",
      item_variant_id: item.variant_id,
      item_variant_title: item.variant_title || "",
      item_product_id: item.product_id,
      item_product_title: item.product_title,
      item_name: item.title,
      discount: item.line_level_discount_allocations.length > 0 ? item.line_level_discount_allocations.map((d) => d.amount).join(", ") : "",
      price: item.price / 100,
      item_brand: item.vendor || "",
      item_category: "",
      item_list_id: item.properties._collectionId ? Number(item.properties._collectionId) : null,
      item_list_name: item.properties._collectionTitle ? item.properties._collectionTitle : "",
      sku: item.sku || ""
    }));
    window.dataLayer.push({
      event: "view_cart_ta",
      ecommerce: {
        items
      }
    });
  }).catch((error) => {
    console.error("Error fetching cart:", error);
  });
}
async function fetchRetailRecommendations({ type, products, pageSize }) {
  const myHeaders = new Headers();
  const RECOMMENDATION_URL = "https://labourseauxlivres.fr/apps/bal-retail/retailRecommendation";
  const visitorId = localStorage.getItem("visitorId");
  myHeaders.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({
      data: {
        type,
        products,
        visitorId,
        pageSize
      }
    }),
    redirect: "follow"
  };
  try {
    const recommendationsResponse = await fetch(
      RECOMMENDATION_URL,
      requestOptions
    );
    if (!recommendationsResponse.ok) {
      throw new Error(`Error fetching recommendations: ${recommendationsResponse.status}`);
    }
    const json = await recommendationsResponse.json();
    if (json.attributionToken) {
      sessionStorage.setItem("attributionToken", json.attributionToken);
    }
    if (typeof enableRetailRecommendationTestData !== "undefined" && enableRetailRecommendationTestData) {
      const testAttributionToken = "ChQxMTk1NDI0NTEzNjc4OTk3ODE1OBACGiFmYnRfY2FydF9mcmVxdWVudGx5XzE3MjU2MDYyMDE1NjUiCGZidC1jYXJ0KAA6KIzy0RKy8dES-vHRErTx0RKp8tESj_LREvfx0RKt8tESvvLRErvy0RI";
      sessionStorage.setItem("attributionToken", testAttributionToken);
    }
    return json;
  } catch (err) {
    console.error(`error while fetching recommendation: ${err}`);
  }
}
export {
  formatMoney as a,
  fetchRetailRecommendations as f,
  pushCartDataLayer as p
};
//# sourceMappingURL=g-utils.8c594119.chunk.js.map
